/**
 * Общий форматтер «Воронок уровней»
 * ==================================
 *
 * Один fmtPct на весь виджет — принципиально: сервер отдаёт только числители и
 * знаменатели, все проценты считает клиент, и именно поэтому галка «показывать
 * абсолютные числа» бесплатна и не даёт пропусков. Использовать локальные
 * toFixed(1) + '%' в обход этого файла запрещено (см. план дашборда, §1.5).
 */

/** Целое число с разделителем разрядов (неразрывный пробел, как везде в проекте). */
export function fmtInt(n) {
  return Number(n || 0).toLocaleString('ru-RU', { maximumFractionDigits: 0 });
}

/**
 * Процент num/den. den = 0/null/undefined → «—» (не 0%, чтобы не путать
 * «нет данных» с «нулевая конверсия»).
 * @param {number|null|undefined} num
 * @param {number|null|undefined} den
 * @param {boolean} showAbs — приписать «(num / den)» в скобках
 */
export function fmtPct(num, den, showAbs = false) {
  if (!den) return '—';
  const pct = (Number(num || 0) / den) * 100;
  const base = `${pct.toFixed(1)}%`;
  return showAbs ? `${base} (${fmtInt(num)} / ${fmtInt(den)})` : base;
}

/** Секунды с одним знаком после запятой; null/undefined → «—». */
export function fmtSec(sec) {
  if (sec === null || sec === undefined) return '—';
  return `${Number(sec).toFixed(1)} с`;
}

/** Дробное число (например, среднее число звёзд) с заданной точностью. */
export function fmtNum(n, digits = 2) {
  if (n === null || n === undefined) return '—';
  return Number(n).toFixed(digits);
}
